<article class="cart-item">
  <figure class="cart-item__media">
    <span
      class="d-none chip-label type-body-sm chip--outline text-uppercase chip--primary"
      *ngFor="let label of discountLabels"
      [title]="label.title"
    >
      <span class="truncate">{{ label.title }}</span>
    </span>
    <div class="cart-item__media__inner">
      <img class="product-image product-image-ratio" [src]="line.merchandise.image.url" [alt]="line.merchandise.image.altText" />
    </div>
  </figure>

  <main class="cart-item__details">
    <div class="cart-item__details__header">
      <button
        class="button button--secondary button-icon button--xs float-end ms-2 cart-item__details__remove"
        (click)="removeProduct(line.id)"
      >
        <app-icon anchor="icon-close-xs"></app-icon>
      </button>
      <h3 class="cart-item__title">
        <a class="block-link" [routerLink]="['/products', line.merchandise.product.handle]">
          {{ line.merchandise.product.title }}
        </a>
      </h3>

      <strong class="d-block" *ngIf="line.merchandise.product.productType">
        {{ line.merchandise.product.productType }}
      </strong>
      <!-- TODO// Category product -->
      <div class="d-flex flex-wrap" *ngIf="line?.discountAllocations?.length">
        <del class="type-body-md fw-semi price--old">
          {{ line.cost.amountPerQuantity.amount | currency : line.cost.amountPerQuantity.currencyCode }}
        </del>
        <strong class="fw-semi type-body-md ms-1 price--new" *ngIf="cartLoading !== true">
          {{ getFinalUnitPriceAmount(line) | currency : line.cost.amountPerQuantity.currencyCode }}
        </strong>
      </div>
      <em class="type-body-md fw-bold d-inline-block mb-2" *ngIf="!line.discountAllocations.length">
        <del *ngIf="+line.cost.compareAtAmountPerQuantity?.amount > line.cost.amountPerQuantity.amount" class="price--old">
          {{ line.cost.compareAtAmountPerQuantity?.amount | currency : line.cost.compareAtAmountPerQuantity?.currencyCode }}
        </del>
        <span [class.price--new]="+line.cost.compareAtAmountPerQuantity?.amount > line.cost.amountPerQuantity.amount">
          {{ line.cost.amountPerQuantity.amount | currency : line.cost.amountPerQuantity.currencyCode }}
        </span>
      </em>

      <ul class="">
        <li class="me-1 type-body-sm" *ngIf="line.merchandise?.sku">
          {{ 'winkelwagen-artikelnummer-label' | fromDictionary }} {{ line.merchandise.sku }}
        </li>
        <ng-container *ngIf="line?.merchandise?.selectedOptions">
          <li class="me-1 type-body-sm" *ngIf="line.merchandise.product | metaColorLabel : 'kleur_label'">
            Print - {{ line.merchandise.product | metaColorLabel : 'kleur_label' }}
          </li>

          <li class="me-1 type-body-sm" *ngIf="line.merchandise.product | metaColorLabel : 'kleur_filter'">
            Kleur - {{ line.merchandise.product | metaColorLabel : 'kleur_filter' }}
          </li>
          <ng-container *ngFor="let option of line?.merchandise?.selectedOptions">
            <li class="me-1 type-body-sm" *ngIf="option.name !== 'Title'">{{ option.name }} - {{ option.value }}</li>
          </ng-container>
        </ng-container>
      </ul>
    </div>

    <div class="pt-4 cart-item__details__footer">
      <div class="amount-chooser mb-sm-0">
        <button
          class="button button--secondary button-icon button--xs button-outline"
          (click)="changeQuantity(+line.quantity - 1, line.id)"
          [disabled]="linesLoading.includes(line.id) || line.quantity <= 1"
        >
          <app-icon anchor="icon-minus"></app-icon>
        </button>

        <div class="button button-outline button--secondary amount-chooser__amount">
          <input
            type="number"
            [formControl]="amountField"
            placeholder="Aantal"
            (change)="changeQuantity(+(amountInput.value || 0), line.id)"
            #amountInput
          />
          <!-- <span class="chip me-2">{{ line.quantity }}</span>
          <span class="amount-chooser__suffix">{{ (getUnit(line) ?? '') || ('product-aantal-suffix' | fromDictionary) }}</span> -->
        </div>

        <button
          class="button button--xs button-icon button--secondary"
          (click)="changeQuantity(+line.quantity + 1, line.id)"
          [disabled]="maxReached(line)"
          [title]="maxReached(line) ? ('winkelwagen-max-bereikt-waarschuwing' | fromDictionary) : 'add'"
        >
          <app-icon anchor="icon-plus"></app-icon>
        </button>
      </div>
      <!-- <div class="alert" *ngIf="getMaxQuantity(line.merchandise) > -1 && getMaxQuantity(line.merchandise) <= line.quantity">
        TODO: alert Max reached (max: {{ getMaxQuantity(line.merchandise) }})
      </div> -->
      <div class="cart-item__total my-auto">
        <app-icon class="anim--spinning" anchor="icon-loader" *ngIf="linesLoading.includes(line.id)"></app-icon>
        <div class="cart-item__total__price" *ngIf="!linesLoading.includes(line.id)">
          <del class="price--old" *ngIf="line?.discountAllocations?.length; else discountCompare">
            {{ line.cost.subtotalAmount.amount | currency : line.cost.subtotalAmount.currencyCode }}
          </del>
          <ng-template #discountCompare>
            <del *ngIf="+line.cost.compareAtAmountPerQuantity?.amount > line.cost.amountPerQuantity.amount" class="price--old">
              {{ +line.cost.compareAtAmountPerQuantity?.amount * line.quantity | currency : line.cost.amountPerQuantity.currencyCode }}
            </del>
          </ng-template>
          <span
            [class.price--new]="
              line.discountAllocations.length || +line.cost.compareAtAmountPerQuantity?.amount > line.cost.amountPerQuantity.amount
            "
          >
            {{ line.cost.totalAmount.amount | currency : line.cost.totalAmount.currencyCode }}
          </span>
        </div>
      </div>
    </div>
  </main>
</article>
